import {
    MutableRefObject, useCallback, useState,
} from 'react'
import {
    Action,
} from 'app/PoC/DataGridDemoPages/components/SkyNetDataGridExpandable/SkyNetDataGridExpandable.types'
import {
    ExtendedGridApiPro, SkyBaseDataSourceProvider,
} from 'app/PoC/DataGridDemoPages/components/SkyBaseDataGrid'

export default function useExpandableActions({
    apiRef, dataSource,
}: {
    apiRef: MutableRefObject<ExtendedGridApiPro>,
    dataSource: SkyBaseDataSourceProvider
}) {
    const refetch = useCallback(async () => {
        dataSource.invalidate()
        await apiRef?.current?.dataSource.fetchRows()
    }, [
        apiRef,
        dataSource,
    ])

    const [
        actionId,
        setActionId,
    ] = useState<number | string | null>(null)

    const [
        action,
        setAction,
    ] = useState<Action | undefined>(undefined)

    const copy = useCallback((id: number | string) => {
        setActionId(id)
        setAction(Action.Copy)
    }, [])

    const create = useCallback(() => {
        setAction(Action.Create)
    }, [])

    const clearAction = useCallback(() => {
        setActionId(null)
        setAction(undefined)
    }, [])

    const collapseAll = useCallback(() => {
        apiRef?.current?.setExpandedDetailPanels(new Set())
    }, [apiRef])

    const collapse = useCallback((id: number | string) => {
        const openedPanelsIds = apiRef?.current?.getExpandedDetailPanels()

        openedPanelsIds.delete(id)

        apiRef?.current?.setExpandedDetailPanels(new Set(openedPanelsIds))
    }, [apiRef])

    const expand = useCallback((id = actionId) => {
        const openedPanelsIds = apiRef?.current?.getExpandedDetailPanels()

        if (id) {
            apiRef?.current?.setExpandedDetailPanels(openedPanelsIds.add(id))
        }
    }, [
        actionId,
        apiRef,
    ])

    return {
        action,
        actionId,
        clearAction,
        collapse,
        collapseAll,
        copy,
        create,
        expand,
        refetch,
    }
}
